import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MapPin, Building2, Users, Star, Award, Clock } from 'lucide-react';

const LocationsStats: React.FC = () => {
  return (
    <section className="py-16 bg-muted/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Comprehensive Eastern NC Coverage</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            From the Triangle to the Outer Banks, we provide expert roofing services across 
            Eastern North Carolina with local teams who understand regional challenges.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <Card className="text-center">
            <CardHeader>
              <CardTitle className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <MapPin className="h-6 w-6 text-primary" />
                </div>
                Service Locations
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-primary mb-2">200+</div>
              <p className="text-muted-foreground">
                Cities and towns across Eastern North Carolina
              </p>
            </CardContent>
          </Card>

          <Card className="text-center">
            <CardHeader>
              <CardTitle className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Building2 className="h-6 w-6 text-primary" />
                </div>
                Counties Served
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-primary mb-2">25+</div>
              <p className="text-muted-foreground">
                Counties from the Triangle to the Coast
              </p>
            </CardContent>
          </Card>

          <Card className="text-center">
            <CardHeader>
              <CardTitle className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Users className="h-6 w-6 text-primary" />
                </div>
                Local Teams
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-3xl font-bold text-primary mb-2">50+</div>
              <p className="text-muted-foreground">
                Certified professionals serving your community
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Star className="h-5 w-5 text-yellow-500" />
                Local Expertise
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Our teams understand local building codes, weather patterns, and architectural styles 
                specific to each region we serve.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Award className="h-5 w-5 text-primary" />
                Quality Guarantee
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Every project backed by our comprehensive workmanship warranty and 
                manufacturer guarantees for peace of mind.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Clock className="h-5 w-5 text-green-500" />
                Rapid Response
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Emergency storm damage response and quick project turnaround times 
                with local dispatch centers.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 p-6 bg-primary/5 rounded-lg text-center">
          <h3 className="text-xl font-semibold mb-3">Can't Find Your Location?</h3>
          <p className="text-muted-foreground mb-4">
            We're expanding our service area constantly. Contact us to see if we serve your area 
            or can connect you with a trusted partner in your region.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocationsStats;